import { defineMessages } from '../define';
import { plural } from '..';

/** Лента трат. */
export const pagesFeed = defineMessages({
  ru: {
    'feed.title': 'Лента',
    'feed.count': (p: { n: number }) => `${p.n} ${plural(p.n, { one: 'трата', few: 'траты', many: 'трат', other: 'траты' })}`,
    'feed.envelopeAria': 'Конверт',
    'feed.all': 'Все',
    'feed.emptyTitle': 'Трат нет',
    'feed.emptyAll': (p: { period: string }) => `За ${p.period} пока ничего`,
    'feed.emptyEnvelope': 'В этом конверте за период пусто',
  },
  en: {
    'feed.title': 'Feed',
    'feed.count': (p: { n: number }) => `${p.n} ${plural(p.n, { one: 'expense', other: 'expenses' })}`,
    'feed.envelopeAria': 'Envelope',
    'feed.all': 'All',
    'feed.emptyTitle': 'No expenses',
    'feed.emptyAll': (p: { period: string }) => `Nothing yet for ${p.period}`,
    'feed.emptyEnvelope': 'This envelope is empty for the period',
  },
  be: {
    'feed.title': 'Стужка',
    'feed.count': (p: { n: number }) => `${p.n} ${plural(p.n, { one: 'трата', few: 'траты', many: 'трат', other: 'траты' })}`,
    'feed.envelopeAria': 'Канверт',
    'feed.all': 'Усе',
    'feed.emptyTitle': 'Трат няма',
    'feed.emptyAll': (p: { period: string }) => `За ${p.period} пакуль нічога`,
    'feed.emptyEnvelope': 'У гэтым канверце за перыяд пуста',
  },
});
